module.exports = __webpack_public_path__ + "static/img/3areaB_4.cc37209.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_4.png
// module id = 1167
// module chunks = 1